import { useTranslation } from 'react-i18next';
import {
    Typography,
    InputAdornment,
    Checkbox,
    TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Search, CheckBoxOutlineBlank, CheckBox } from '@material-ui/icons';
import { getProfileStatusLabel } from '../../../Enums/Helpers/LabellingHelper';
import { BidProfileStatus } from '../../../Enums';
import './FilterSelectionBar.scss';

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;
/**
 * @param {{ setStatusFilterSelected: Function; searchValue: string; setSearchValue: Function; allStatus: BidProfileStatus[]; statusFilterSelected: BidProfileStatus[] }} props
 */
function FilterSelectionBar({
    setStatusFilterSelected, searchValue, setSearchValue, allStatus, statusFilterSelected
}) {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'manager.biddingList' });

    return (
        <>
            <div className="fsb-status-filter-container">
                <Typography
                    component="p"
                    className="fsb-input-label"
                >
                    {t('status')}
                </Typography>
                <Autocomplete
                    multiple
                    id="bidding-list-status-multiple-select"
                    className="bidding-list-status-multiple-select"
                    limitTags={1}
                    options={allStatus}
                    disableCloseOnSelect
                    getOptionLabel={(option) => getProfileStatusLabel(option)}
                    onChange={(event, values) => setStatusFilterSelected(values)}
                    defaultValue={statusFilterSelected}
                    renderOption={(option, { selected }) => (
                        <>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                                color="primary"
                            />
                            {getProfileStatusLabel(option)}
                        </>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                            variant="outlined"
                            label=""
                        />
                    )}
                    renderTags={(value) => {
                        const numTags = value.length;

                        return (
                            <Typography variant="body2">
                                {value
                                    .slice(0, 2)
                                    .map((option) => getProfileStatusLabel(option))
                                    .join(', ')}

                                {numTags > 2 && ` +${numTags - 2} more`}
                            </Typography>
                        );
                    }}
                />
            </div>
            <div className="fsb-search-bar-container">
                <Typography
                    component="p"
                    className="fsb-input-label"
                >
                    {t('search')}
                </Typography>
                <TextField
                    id="react-search-input"
                    size="small"
                    variant="outlined"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    InputProps={{
                        startAdornment:
                            (
                                <InputAdornment position="start">
                                    <Search />
                                </InputAdornment>
                            ),
                    }}
                />
            </div>
        </>
    );
}

export default FilterSelectionBar;
